/** @jsxImportSource @emotion/react */
import * as s from './style'
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_URL } from 'config/URL/URL';
import SelectMemuItem from 'components/atoms/table_element/SelectMemuItem';

const CategoryMenu = ({ selectedCategory, setSelectedCategory }) => {
  const [ categoryData, setCategoryData ] = useState();
  const [ selectedCategoryGroup, setSelectedCategoryGroup ] = useState();

  useEffect(() => {
    fetchInit();
  }, []);

  useEffect(() => {
    if(categoryData) {
      const newGroup = categoryData.find((group) => group.categoryCd === selectedCategory.categoryCd[0]);
      setSelectedCategoryGroup(newGroup);
    }
      
  }, [selectedCategory])

  const fetchInit = async () => {
    try {
      const resultArray = await getCategoryData();
      setCategoryData(resultArray);

      const initGroupKey = resultArray[0].categoryCd;
      const initCategoryKey = resultArray[0].categories[0].categoryCd;
      
      const initCategoryGroup = resultArray.find(categoryGroup => categoryGroup.categoryCd === initGroupKey);
      const initCategory = initCategoryGroup.categories.find(category => category.categoryCd === initCategoryKey);

      const newData = await getDataByCategory(initCategory.categoryCd);

      initCategory.data = newData;
      initCategory.year = initCategory.end_yyyy;

      setSelectedCategoryGroup(initCategoryGroup);
      setSelectedCategory(initCategory);

    } catch (error) {
      console.error(error);
    }
  };

  const getCategoryData = async () => {
    const response = await axios.get(`${API_URL}/sodamap-api/category`);
    response.data.sort((a, b) => a.nm_kor.localeCompare(b.nm_kor));

    const resultArray = response.data.filter(item => item.category === "main");

    resultArray.forEach((group) => {
      const groupItem = response.data.filter(item => item.categoryCd[0] === group.categoryCd && item.category !== "main");
      group.categories = groupItem;
    })

    return resultArray;
  }

  const getDataByCategory = async (categoryCd) => {
    const option = {
        params: {
            category_cd: categoryCd
        }
    }
    try {
        const response = await axios.get(`${API_URL}/sodamap-api/category/data`, option);

        return response.data;
    } catch(error){
        console.log(error)
    }
  }

  const onClickCategoryGroupHandle = async (categoryGroup) => {
    setSelectedCategoryGroup(categoryGroup);
  }

  const onClickCategoryHandle = async (category) => {
    category.data = await getDataByCategory(category.categoryCd);
    setSelectedCategory(category);
  }
    
  if(categoryData && selectedCategoryGroup)
  return (
      <div css={s.mainContainer}>
        <div css={s.col}>
          <header css={s.header}>분류</header>
          <div css={s.content}>
            {categoryData.map((categoryGroup, idx) =>
              <SelectMemuItem 
                key={idx}
                isSelected={categoryGroup.categoryCd === selectedCategoryGroup.categoryCd}
                onClick={() => onClickCategoryGroupHandle(categoryGroup)}>
                {categoryGroup.nm_kor}
              </SelectMemuItem>
            )}
          </div>
        </div>

        <div css={s.col}>
          <header css={s.header}>분류별 주제</header>
          <div css={s.content}>
            {selectedCategoryGroup.categories.map((category, idx) => 
              <SelectMemuItem 
                key={idx}
                isSelected={category.categoryCd === selectedCategory.categoryCd}
                onClick={() => onClickCategoryHandle(category)}>
                {category.nm_kor}
              </SelectMemuItem>
            )}
          </div>

        </div>
        <div css={s.col}>
          <header css={s.header}>Tip</header>
          <div css={s.content}>
            <span css={s.tipText}>{selectedCategory.tip}</span>
          </div>
        </div>
      </div>
  );
};

export default CategoryMenu;